import { Directive, HostListener, ElementRef, Renderer2 } from '@angular/core';

/**
 * This directive removes focus from the selectors after clicking on them
 */
@Directive({
  // tslint:disable-next-line:directive-selector
  selector: 'button, a'
})

export class FocusRemoverDirective {
  constructor(private elRef: ElementRef, private renderer: Renderer2) { }

  @HostListener('click') onClick() {
    setTimeout(() => {
      this.renderer.removeClass(this.elRef.nativeElement, 'active');
    }, 200);
  }
  @HostListener('mouseover') onMouseOver() {
    this.renderer.addClass(this.elRef.nativeElement, 'active');
  }
  @HostListener('mouseout') onMouseOut() {
    this.renderer.removeClass(this.elRef.nativeElement, 'active');
  }
}
